// action
export const getCategory = (state, val) => {
  state.categories = val
}

export const categoryList = (state, val) => {
  state.lists = val
}

export const categoryForm = (state, val) => {
  state.category = val
}
